import FormErrors from "../utils/FormErrors";

export default {
  namespaced: true,
  state: {
    api: {},
    current_page: 1,
    per_page: 10,
    total: null,
    items: null,
    last_page: null,
    filters: null,
    mail: [],
    brand: null,
    selected_brand: { '': 'Alle' },
    file: null,
    errors: new FormErrors(),
  },
  mutations: {
    SET_ITEM(state, data) {
      const index = data[2];
      const key = data[0];
      const value = data[1];
      if (Array.isArray(state[key])) {
        const result = [...state[key]];
        result[index] = value;
        index != null ? (state[key] = result) : (state[key] = value);
      } else state[key] = value;
    },
    DELETE_BLACKLIST(state, task) {
      const item = state.items.find((item) => item.id == task);
      const index = state.items.indexOf(item);
      state.items.splice(index, 1);
    },
  },
  actions: {
    async SET_API({ commit, dispatch }, api) {
      commit('SET_ITEM', ['api', api]);
      dispatch('GET_BLACKLIST');
    },
    async GET_BLACKLIST({ commit, state }) {
      let response = await axios.get(state.api.list, {
        params: {
          page: state.current_page,
          per_page: state.per_page,
          brand_id: Object.keys(state.selected_brand)[0],
        },
      });
      response = response.data;
      commit('SET_ITEM', ['items', response.data]);
      commit('SET_ITEM', ['total', response.total]);
      commit('SET_ITEM', ['last_page', response.last_page]);
      commit('SET_ITEM', ['filters', response.filters]);
      commit('SET_ITEM', ['current_page', response.current_page]);
    },
    SELECT_FILTER({ commit, dispatch }, data) {
      commit('SET_ITEM', data);
      dispatch('GET_BLACKLIST');
    },
    SELECT_ENTRIES({ commit, dispatch }, data) {
      commit('SET_ITEM', ['per_page', data]);
      dispatch('GET_BLACKLIST');
    },
    CHANGE_PAGE({ commit, dispatch }, page) {
      commit('SET_ITEM', ['current_page', page]);
      dispatch('GET_BLACKLIST');
    },
    async DELETE_BLACKLIST({ commit, state }, task) {
      const response = await axios.delete(state.api.delete, {
        params: { id: task },
      });
      if (response.data.message == 'Success') {
        commit('DELETE_BLACKLIST', task);
        commit('TOGGLE_CONFIRMATION', null, { root: true });
      }
    },
    VALIDATE_BLACKLIST({ dispatch, state }, id) {
      if (state.mail && state.brand) {
        dispatch('CREATE_BLACKLIST', id);
      } else {
        this._vm.$notify({
          group: 'foo',
          type: 'error',
          title: 'Wichtige Mitteilung',
          text: 'Nicht alle Pflichtfelder ausgefüllt.',
        });
      }
    },
    async CREATE_BLACKLIST({ commit, state }, id) {
      try {
        if (id) {
          const response = await axios.post(state.api.edit_link, {
            email: state.mail,
            brand_id: state.brand,
            id,
          });
        } else {
          const response = await axios.post(state.api.create_link, {
            emails: state.mail,
            brand_id: state.brand,
          });
        }
        GlobalEvents.fire('alert', [{ message: 'Eintrag erfolgreich angelegt.', type: 'success' }]);
        window.location.href = state.api.back_link;
      } catch (err) {
        state.errors.record(err?.response?.data?.errors);
      }
    },
    async UPLOAD({ commit, state }) {
      const formData = new FormData();
      formData.append('file', state.file[0], state.file[0].name);
      formData.append('brand_id', state.brand);
      try {
        const response = await axios.post(state.api.upload, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        window.location.href = state.api.back_link;
      } catch (err) {
        if (err.response?.data?.errors) {
          for (const error in err.response.data.errors) {
            this._vm.$notify({
              group: 'foo',
              type: 'error',
              title: 'Wichtige Mitteilung',
              text: err.response.data.errors[error][0],
            });
          }
        } else {
          this._vm.$notify({
            group: 'foo',
            type: 'error',
            title: 'Wichtige Mitteilung',
            text: err,
          });
        }
      }
    },
  },
};
